package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * 元素上的有序视觉 modifier。
 *
 * 字段值沿用元素 prop 表达式模型，便于 codegen 直接复用 UiBinding 生成逻辑。
 */
data class ModifierAst(
    val kind: String,
    val fields: List<ElementAst.PropAssign>,
    override val position: SourcePosition,
    val useName: String? = null,
    val condition: ExprAst? = null,
    val children: List<ModifierAst> = emptyList(),
) : AstNode

data class ModifierBundleAst(
    val name: String,
    val modifiers: List<ModifierAst>,
    override val position: SourcePosition,
) : AstNode
